
import { UIActionKey } from '../../../types';

export const uiActions: Record<UIActionKey, string> = {
  cancel: 'Cancelar',
  save: 'Salvar',
  delete: 'Excluir',
  edit: 'Editar',
  close: 'Fechar',
  apply: 'Aplicar',
  or: 'ou',
  selectFile: 'Selecionar Arquivo',
  dragToUpload: 'Arraste para enviar',
  copied: 'Copiado',
  preview: 'Visualizar',
  saveAll: 'Salvar Tudo',
  change: 'Alterar',
  remove: 'Remover',
  saveChanges: 'Salvar Alterações',
  updatePassword: 'Atualizar Senha',
  all: 'Todos',
  completed: 'Concluídos',
  status: 'Status'
};
